import { useEffect, useState } from 'react';
import { getEarnCoins, subscribeEarnCoins } from '../services/users/earnCatalog';

/** Live earn amounts. Falls back to shipped defaults until Admin config loads. */
export function useEarnCatalog() {
  const [coins, setCoins] = useState(getEarnCoins);
  useEffect(() => subscribeEarnCoins(setCoins), []);
  return coins;
}
